import React from 'react';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { CSSObject, CSSProp } from 'styled-components';

import { VideoWithThumbnail } from 'src/components/atoms/VideoWithThumbnail/VideoWithThumbnail';
import { Row } from 'src/styles/layout';
import { CSSVarTitle, SubTitle, Title } from 'src/styles/layout.styles';
import { VideoBlockProps } from 'src/types/Video';
import * as styles from './VideoBlock.style';

interface VideoProps extends VideoBlockProps {
  customTrackClick: () => void;
  headingStyles?: CSSProp | CSSObject;
  noPadding: boolean;
}

interface VideoBlockEvent {
  event: 'custom_event';
  event_category: 'Youtube video';
  event_action: 'click';
  event_label: string;
}

export const VideoBlock = ({
  heading,
  subHeading,
  copyBlock,
  video: { youtubeID, thumbnail },
  headingStyles,
  noPadding,
  customTrackClick,
}: VideoProps) => {
  const trackClick = () => {
    sendGAEvent<VideoBlockEvent>({
      event: 'custom_event',
      event_category: 'Youtube video',
      event_action: 'click',
      event_label: heading ? `${heading.toUpperCase()} | ${youtubeID}` : youtubeID,
    });
  };

  const renderHeading = () => (
    <>
      <h2 css={headingStyles || styles.VideoBlockHeading} data-with-sub-heading={!!subHeading}>
        {heading}
      </h2>
      {subHeading && <p css={styles.StyledSubTitle}>{subHeading}</p>}
    </>
  );

  const renderCopyBlock = () => (
    <div css={styles.CopyBlockWrapper}>
      {copyBlock.heading && (
        <h3
          css={Title}
          style={{ '--topMargin': '19px', '--uppercase': 'uppercase' } as CSSVarTitle}
        >
          {copyBlock.heading}
        </h3>
      )}
      <p css={SubTitle}>{copyBlock.copy}</p>
    </div>
  );

  return (
    <div css={styles.Container} data-no-padding={noPadding}>
      {heading && renderHeading()}
      <div css={styles.VideoBlockRow} data-margin-top={!heading}>
        <Row>
          <div css={styles.VideoBlockWrapper}>
            <VideoWithThumbnail
              youtubeId={youtubeID}
              thumbnail={thumbnail && thumbnail.url}
              trackClick={customTrackClick || trackClick}
            />
          </div>
          {copyBlock.copy && renderCopyBlock()}
        </Row>
      </div>
    </div>
  );
};
